import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../Table/DetailsTable';
import FeatureSummary from '../../Util/FeatureSummary';

const CoBrandTable = ({ cobrands, setSelectedCoBrand, loading, editOnClick, createOnClick, previewOnClick }) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.coBrandID} />
            ),
        },
        {
            name: 'CoBrandID',
            fieldName: 'coBrandID',
            minWidth: 120,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Name',
            fieldName: 'name',
            minWidth: 140,
            maxWidth: 140,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Home Hero Header',
            fieldName: 'homeHeroHeader',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Home Hero Subheader',
            fieldName: 'homeHeroSubheader',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
        },
    ];

    const items = cobrands ?? [];

    const selectionHook = (items) => {
        setSelectedCoBrand(items && items[0] && items[0].Name);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionHook={selectionHook}
                selectionMode="none"
                loading={loading}
                mainColumn={'title'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <>
                        <CommandBarButton
                            iconProps={{ iconName: 'Edit' }}
                            text="Create New Hub"
                            onClick={() => createOnClick()}
                        />
                    </>
                }
            />
            <FeatureSummary
                label="About Cobrand Hubs"
                summary="This table displays the home page settings for all cobrands, including their name, hero header, and subheader. This feature allows admins to manage the logged out home page appearance."
                imageUrlPath="hub-settings-1"
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default CoBrandTable;
